import contains from '@utils/contains';

class Filters {
  constructor() {
    this.animationTimeout = 300;
    this.button = document.querySelector('#rooms-filter__button');
    this.buttonLabels = document.querySelectorAll('.rooms-filter__button-label');
    this.items = document.querySelectorAll('.rooms-cards__item');
    this.filters = document.querySelectorAll('.rooms-filter__item:not(:first-child)');
    this.allFilterItem = document.querySelector('.rooms-filter__item:first-child');
    this.resultCount = document.querySelector('.rooms-filter__result');
    this.content = document.getElementById(this.button.getAttribute('aria-controls'));

    this.state = {
      types: [],
      resultCount: this.items.length,
    };

    this.open = this.button.getAttribute('aria-expanded') === 'true';
  }

  init = () => {
    this.button.addEventListener('click', this.onButtonClick);

    this.filters.forEach((filter) => {
      filter.addEventListener('click', this.onFilterClick);
      filter.addEventListener('keydown', this.onFilterClick);

      filter.querySelectorAll('svg').forEach((filterSVG) => {
        filterSVG.addEventListener('click', (e) => {
          e.preventDefault();
          filter.click();
        });
      });
    });

    this.allFilterItem.addEventListener('click', this.clearFilters);
    this.allFilterItem.addEventListener('keydown', this.clearFilters);
  };

  onButtonClick = () => {
    this.toggle(!this.open);
  };

  toggle = (open) => {
    if (open === this.open) {
      return;
    }

    this.open = open;

    this.button.setAttribute('aria-expanded', `${open}`);
    this.content.setAttribute('aria-hidden', !open);
    this.buttonLabels.forEach((label) => {
      label.classList.toggle('rooms-filter__button-label--hidden');
    });

    if (!this.open) {
      this.clearFiltersCallback();
    }
  };

  open = () => {
    this.toggle(true);
  };

  close = () => {
    this.toggle(false);
  };

  onFilterClick = (e) => {
    // accessebility for filters
    if (e.type === 'keydown' && !['Enter', 'Space'].includes(e.code)) {
      return;
    }
    e.preventDefault();

    if (e.target.ariaChecked !== 'true') {
      // push checked filter to state
      if (e.target.dataset.filter) {
        this.state.types.push(e.target.dataset.filter);
      }
      this.toggleFIlter(e.target);
    } else {
      this.toggleFIlter(e.target, 'false');

      // remove checked filter to state
      const index = this.state.types.indexOf(e.target.dataset.filter);
      if (index > -1) {
        this.state.types.splice(index, 1);
      }
    }

    if (!this.state.types.length) {
      this.toggleFIlter(this.allFilterItem);
    } else {
      this.toggleFIlter(this.allFilterItem, 'false');
    }

    this.updateItemsVisibility(this.items);
  };

  updateItemsVisibility = (items) => {
    items.forEach((card) => {
      // check if state contains card type or checked all filters
      if (contains(this.state.types, card.dataset.type.split('|')) || !this.state.types.length) {
        if (card.style.display !== 'block') {
          this.fadeIn(card);
        }
      } else {
        this.fadeOut(card);
      }
    });

    setTimeout(() => {
      this.state.resultCount = this.getCountVisibleCards();
      this.resultCount.innerHTML = `${this.state.resultCount} ${this.state.resultCount === 1
        ? localizedFilterData.result : localizedFilterData.results}`; // eslint-disable-line
    }, this.animationTimeout);
  };

  clearFilters = (e) => {
    // accessebility for filters
    if (e.type === 'keydown' && !['Enter', 'Space'].includes(e.code)) {
      return;
    }
    e.preventDefault();

    this.clearFiltersCallback();
  };

  clearFiltersCallback = () => {
    this.toggleFIlter(this.allFilterItem);

    this.filters.forEach((filter) => {
      this.toggleFIlter(filter, 'false');
    });

    if (this.state.types.length) {
      this.state.types = [];
    }

    this.updateItemsVisibility(this.items);
  };

  toggleFIlter = (filter, state = 'true') => {
    if (filter === this.allFilterItem) {
      filter.querySelector(`.rooms-filter__item-icon:${state === 'true' ? 'last' : 'first'}-child`).classList.add('rooms-filter__item-icon--hidden');
      filter.querySelector(`.rooms-filter__item-icon:${state === 'true' ? 'first' : 'last'}-child`).classList.remove('rooms-filter__item-icon--hidden');
    } else {
      filter.querySelectorAll('.rooms-filter__item-icon').forEach((icon) => {
        if (state !== filter.ariaChecked) icon.classList.toggle('rooms-filter__item-icon--hidden');
      });
    }

    filter.setAttribute('aria-checked', state);
  };

  /* eslint-disable no-param-reassign */
  fadeIn = (el) => {
    this.state.resultCount++;
    el.style.display = 'block';
    setTimeout(() => { el.style.opacity = 1; });
  };

  fadeOut = (el) => {
    el.style.opacity = 0;
    setTimeout(() => { el.style.display = 'none'; }, this.animationTimeout);
  };
  /* eslint-enable no-param-reassign */

  getCountVisibleCards = () => Array.from(this.items).filter(
    (s) => window.getComputedStyle(s).getPropertyValue('display') !== 'none',
  ).length;
}

document.addEventListener('DOMContentLoaded', () => {
  const filters = new Filters();
  filters.init();
});
